import util from '@/libs/util.js'

export default {
  methods: {
    handleMenuSelect (index, indexPath) {
      if (/^d2-menu-empty-\d+$/.test(index) || index === undefined) {
        this.$message.warning('临时菜单')
      } else if (/^https:\/\/|http:\/\//.test(index)) {
        const userId = util.cookies.get('uuid')
        const token = util.cookies.get('token')
        let url = index
        url = url.replace(/\$\{userId\}/g, userId || '')
        url = url.replace(/\$\{token\}/g, token || '')
        util.open(url)
      } else {
        this.$router.push({
          path: index
        })
      }
    }
  }
}
